import { SummaryPanel } from '@components/panels/SummaryPanel'
import { CurrencyFormat, PercentFormat } from '@components/shared/Format'
import { I18n } from '@components/shared/I18n'
import { Table, TableCell, TableRow } from '@components/shared/Table'
import { WithTooltip } from '@components/shared/WithTooltip'
import { store } from '@stores/Store'
import { observer } from 'mobx-react'
import React, { FunctionComponent } from 'react'
import { useMobile } from 'src/hooks/useMobile'
import styles from './SummaryCorePlanIncome.module.scss'

export const SummaryCorePlanIncome: FunctionComponent = observer(() => {
  const {
    retailMargin, retailMarginAmount, performanceBonus, leadershipBonus, fosterBonus, rubyBonus,
    retailMarginAnnualAmount, performanceBonusAnnual, leadershipBonusAnnual, fosterBonusAnnual,
    rubyBonusAnnual, selectedUA, localizationHelper
  } = store
  const { RUBY_BONUS_TOOLTIP } = localizationHelper
  const { depthBonus, depthBonusAnnual } = store.depthCalculation
  const { totalCorePlanIncomeMonthlyAmount, totalCorePlanIncomeAnnualAmount } = store.summaryCalculation
  const { isMobile } = useMobile()
  const tdTitleStyle = { width: isMobile ? 120 : 340 }
  const tdMonthlyStyle = { width: isMobile ? 80 : 160 }
  const tdAnnualStyle = { width: isMobile ? 88 : 160 }

  return (
    <>
      <div className={styles['wrapper']}>
        <Table>
          {/* Header */}
          <TableRow>
            <TableCell style={tdTitleStyle}>
              <h4><WithTooltip title='CORE_PLAN_INCOME_TOOLTIP' iconPosition='right' iconFloat='right'><I18n name='CORE_PLAN_INCOME' /></WithTooltip></h4>
            </TableCell>
            <TableCell align='right' style={tdMonthlyStyle}><I18n name='MONTHLY_INCOME' /></TableCell>
            <TableCell align='right' style={tdAnnualStyle}><I18n name='ANNUAL_INCOME' /></TableCell>
          </TableRow>

          {/* Retail Margin */}
          {!selectedUA &&
              <TableRow>
                <TableCell><I18n name="RETAIL_MARGIN" /> (<PercentFormat value={retailMargin} />)</TableCell>
                <TableCell align='right'><CurrencyFormat value={retailMarginAmount} /></TableCell>
                <TableCell align='right'><WithTooltip title="RETAIL_MARGIN_AMOUNT_TOOLTIP" iconPosition='right'><CurrencyFormat value={retailMarginAnnualAmount} /></WithTooltip></TableCell>
              </TableRow>
          }

          {/* Performance Bonus */}
          <TableRow>
            <TableCell><I18n name="PERFORMANCE_BONUS" /></TableCell>
            <TableCell align='right'><CurrencyFormat value={performanceBonus} /></TableCell>
            <TableCell align='right'><WithTooltip title="PERSONAL_PERFORMANCE_BONUS_TOOLTIP" iconPosition='right'><CurrencyFormat value={performanceBonusAnnual} /></WithTooltip></TableCell>
          </TableRow>

          {/* Leadership Bonus */}
          <TableRow>
            <TableCell><I18n name="LEADERSHIP_BONUS" /></TableCell>
            <TableCell align='right'><CurrencyFormat value={leadershipBonus} /></TableCell>
            <TableCell align='right'><WithTooltip title="LEADERSHIP_BONUS_TOOLTIP" iconPosition='right'><CurrencyFormat value={leadershipBonusAnnual} /></WithTooltip></TableCell>
          </TableRow>

          {/* Foster Bonus */}
          <TableRow>
            <TableCell><I18n name="FOSTER_BONUS" /></TableCell>
            <TableCell align='right'><CurrencyFormat value={fosterBonus} /></TableCell>
            <TableCell align='right'><WithTooltip title="FOSTER_BONUS_TOOLTIP" iconPosition='right'><CurrencyFormat value={fosterBonusAnnual} /></WithTooltip></TableCell>
          </TableRow>

          {/* Ruby Bonus */}
          <TableRow>
            <TableCell><I18n name="RUBY_BONUS" /></TableCell>
            <TableCell align='right'><CurrencyFormat value={rubyBonus} /></TableCell>
            <TableCell align='right'><WithTooltip title={RUBY_BONUS_TOOLTIP} iconPosition='right'><CurrencyFormat value={rubyBonusAnnual} /></WithTooltip></TableCell>
          </TableRow>

          {/* Depth Bonus */}
          <TableRow>
            <TableCell><I18n name="DEPTH_BONUS" /></TableCell>
            <TableCell align='right'><CurrencyFormat value={depthBonus} /></TableCell>
            <TableCell align='right'><WithTooltip title="DEPTH_BONUS_TOOLTIP" iconPosition='right'><CurrencyFormat value={depthBonusAnnual} /></WithTooltip></TableCell>
          </TableRow>
        </Table>
      </div>

      <SummaryPanel title='CORE_PLAN_VALUE' monthlyAmount={totalCorePlanIncomeMonthlyAmount} annualAmount={totalCorePlanIncomeAnnualAmount} />
    </>
  )
})
